/**
 * Common workbook settings keys.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/service/WorkbookSettingsConstants.java
 */
export const WORKBOOK_SETTINGS_CONSTANTS = {
  WORKBOOK_PRINT_HEADER_NAME: 'workbook.printHeader.name',
  TIMELINE_3D_ENABLED: 'timeline-3d-view.enabled'
};
